import React, { useState, useContext, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import Switch from "react-switch";
//pages & includes
import ManageSidebar from "../ManageSidebar";
//functions
import {
  _t,
  getCookie,
} from "../../../../../functions/Functions";
//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { FinanceContext } from "../../../../../contexts/Finance";
import { useTranslation } from "react-i18next";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const FoodDepartmentAction = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();
  let {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);
  const { branchForSearch, branchForListSearch, } = useContext(RestaurantContext);
  const { coa3ForSearch } = useContext(FinanceContext)

  // States hook here
  let [newFoodDept, setNewFoodDept] = useState({
    name: "",
    code: "",
    branch: null,
    is_production: 0,
    account_map_id: null,
    status: 1,
    edit: false,
    editSlug: null,
  });

  //set states on edit
  const handleSetEdit = async () => {
    setLoading(true);
    try {
      const deptUrl = BASE_URL + `/settings/food-department/${id}`;
      const response = await axios.get(deptUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setLoading(false);
      const foodDeptEdit = response.data;
      const branch = [];
      foodDeptEdit?.branch_food_department && foodDeptEdit.branch_food_department.map((item)=>{
        branch.push(branchForListSearch[item.branch_id])
      })
      setNewFoodDept({
        ...newFoodDept,
        name: foodDeptEdit.name,
        code: foodDeptEdit.code,
        is_production: foodDeptEdit.is_production,
        account_map_id: foodDeptEdit.accounts ?? null,
        branch: branch,
        status: foodDeptEdit.status,
        edit: true,
        editSlug: id,
      });
    } catch (error) {
      setLoading(false);
      // Handle the error here
      console.error("Error fetching areas:", error);
    }
  };

  useEffect(() => {
    if (id && branchForListSearch) {
      handleSetEdit();
    }
  }, [branchForListSearch]);

  // branch select
  const handleSetNewDept = (e) => {
    const { name, value } = e.target;
    setNewFoodDept({
      ...newFoodDept,
      [name]: value,
    });
  };

  // status change
  const handleChecked = () => {
    setNewFoodDept({
      ...newFoodDept,
      status: newFoodDept.status == 0 ? 1 : 0,
    });
  };

  const handleBranch = (branch) =>{
    setNewFoodDept({
      ...newFoodDept,
      branch,
    });
  }

  const handlePayment =(payment) =>{
    setNewFoodDept({
      ...newFoodDept,
      account_map_id: payment,
    });
  }
  
  //add dept
  const handleSaveNewDept = (e) => {
    e.preventDefault();
    if (!newFoodDept.name || !newFoodDept.code === "") {
      toast.error(`${_t(t("Please select all required fields"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    } else {
      
      setLoading(true);
      const method = id ? "put" : "post";
      const endPoint = id ? ("/settings/food-department/" + id) : "/settings/food-department";
      const deptUrl = BASE_URL + endPoint;
      const branch = newFoodDept.branch ? newFoodDept.branch.map((item)=>item.id) : "";

      let formData = {
        name: newFoodDept.name,
        code: newFoodDept.code,
        branch: branch,
        is_production: newFoodDept.is_production,
        account_id: newFoodDept.account_map_id?.id ?? "",
        status: newFoodDept.status,
      };
      return axios[method](deptUrl, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          if(res){
            setNewFoodDept({
              name: "",
              code: "",
              is_production: 0,
              account_map_id: null,
              branch: null,
              status: 1,
              edit: false,
              editSlug: null,
            });
            setLoading(false);
            toast.success(`${_t(t("Food Department has been added"))}`, {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
            history.push("/dashboard/manage/food/department");
          }
        })
        .catch((error) => {
          setLoading(false);
          if(error.response.data.status === 0){
            toast.error(`${_t(t(error.response.data.message))}`, {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
          }
          toast.error(`${_t(t("Please try again"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        });
    }
  };

  return (
    <div>
      <Helmet>
        <title>{_t(t("Food Department"))}</title>
      </Helmet>
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    {/* {newFoodDept.uploading === true || loading === true ? (
                  tableLoading()
                  ) : ( */}
                    <div key="fragment3">
                      {/* next page data spin loading */}
                      <CustomSpinLoader loading={loading} />
                      {/* spin loading ends */}

                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {!newFoodDept.edit
                                  ? _t(t("Add New Food Dept"))
                                  : _t(t("Update Food Dept"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 col-lg-7">
                          <div className="row gx-3 align-items-center"></div>
                        </div>
                      </div>
                      {/* form start here */}
                      <div key="fragment-branch-1">
                        <form
                          onSubmit={handleSaveNewDept}
                          className="row card p-2 mx-3 mb-5 new-text-style"
                          autoComplete="off"
                        >
                          <div className="row mt-3">
                            <div className="form-group col-6">
                              <label htmlFor="zone" className="form-label">
                                {_t(t("Name"))}{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="name"
                                name="name"
                                placeholder="e.g. BBQ"
                                value={newFoodDept.name || ""}
                                required
                                onChange={handleSetNewDept}
                              />
                            </div>
                            <div className="form-group col-6">
                              <label htmlFor="code" className="form-label">
                                {_t(t("Code"))}{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control "
                                id="code"
                                name="code"
                                placeholder="e.g. bbq"
                                value={newFoodDept.code || ""}
                                required
                                onChange={handleSetNewDept}
                              />
                            </div>
                          </div>

                          <div className="row mt-3">
                            <div className="form-group col-6">
                              <label htmlFor="branch" className="form-label">
                                {_t(t("Branch"))}{" "}
                              </label>
                              <Select
                                options={branchForSearch ? branchForSearch : []}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                value={newFoodDept?.branch}
                                isClearable
                                isMulti
                                classNamePrefix="select"
                                className="table-text"
                                onChange={handleBranch}                                
                                maxMenuHeight="200px"
                                placeholder={_t(t("Select a branch")) + ".."}
                              />
                            </div>
                            <div className="col-2">
                              <label htmlFor="is_production" className="form-label">
                                {_t(t("Production"))}{" "}
                              </label>
                              <div className="mb-2">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="is_production"
                                  name="is_production"
                                  onChange={()=> setNewFoodDept({...newFoodDept, is_production: newFoodDept.is_production ? 0 : 1, account_map_id: null,})}
                                  checked={newFoodDept.is_production}
                                />
                              </div>
                            </div>
                            {
                              newFoodDept.is_production ? (
                                <div className="form-group col-4">
                                  <label htmlFor="branch" className="form-label">
                                    {_t(t("Select Account"))}{" "}
                                  </label>
                                  <Select
                                    options={coa3ForSearch ? coa3ForSearch : []}
                                    getOptionLabel={(option) => option.level3_name}
                                    getOptionValue={(option) => option.id}
                                    value={newFoodDept?.account_map_id}
                                    isClearable
                                    classNamePrefix="select"
                                    className="table-text"
                                    onChange={handlePayment}                                
                                    maxMenuHeight="200px"
                                    placeholder={_t(t("Select account")) + ".."}
                                  />
                                </div>
                              ) : ""
                            }
                          </div>

                          <div className="row mt-3">
                            <div className="form-group col-6">
                              <label
                                htmlFor="status"
                                className="form-label mb-2"
                              >
                                {_t(t("Status"))}{" "}
                              </label>
                              <div className="">
                                <Switch
                                  onChange={handleChecked}
                                  checked={newFoodDept.status === 1}
                                  className="react-switch ml-1"
                                  name="status"
                                  height={20}
                                  width={42}
                                  offColor="#ee5253"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row mt-4">
                            <div className="d-flex justify-content-end">
                              <div className="col-3 d-flex justify-content-end">
                                <button
                                  type="button"
                                  className="btn rounded hov-btn mr-3"
                                  onClick={() =>
                                    history.push(
                                      "/dashboard/manage/food/department"
                                    )
                                  }
                                >
                                  <i
                                    className="fa fa-arrow-left"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  {_t(t("Back"))}
                                </button>
                                <button
                                  type="submit"
                                  className="btn btn-primary rounded"
                                >
                                  <i
                                    className="fa fa-floppy-o"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  {!newFoodDept.edit
                                    ? _t(t("Save"))
                                    : _t(t("Update"))}
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default FoodDepartmentAction;
